import { useRef } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { Button } from "@telegram-apps/telegram-ui";
import { useCommonState } from "~/store";
import { IconPayment, IconCopy, Copy } from "~/components";
import {
    ModalQrCode,
    type ModalQrCodeHandle,
} from "../../components/ModalQrCode/ModalQrCode";
import { tgLink, tgLinkType } from "~/utils/tgLink";
import { hapticFeedback, shareURL } from "@telegram-apps/sdk-react";

export default function InviteBar({ className = "" }) {
    const { t } = useTranslation();
    const { user } = useCommonState();
    const refModalQrCode = useRef<ModalQrCodeHandle>(null);
    const invite_link = tgLink._getLink(tgLinkType.A, {
        invite_user_code: user?.invite_code,
        params: {},
    }) as string;

    function onShareEarnBtc() {
        shareURL(invite_link, t("rebate_share_text"));
    }

    return (
        <div className={clsx(className)}>
            <div className="flex items-center py-[0.5px]">
                <div className="flex-1">
                    <Button
                        className="bg-Orange h-[54px] w-full btn-glisten btn-glisten-time1 rounded-[12px]"
                        type="primary"
                        onClick={onShareEarnBtc}
                    >
                        <span className="text-h6">
                            {t("btn_invite_friends")}
                        </span>
                    </Button>
                </div>

                <Button
                    className="bg-bg_0 block px-0 py-0 w-auto h-auto mx-2"
                    onClick={() => refModalQrCode.current?.open()}
                >
                    <div className="flex items-center justify-center w-[54px] h-[54px] rounded-[12px] border-[0.5px] border-border_warning">
                        <IconPayment className="text-[24px]" />
                    </div>
                </Button>

                <Copy
                    copyText={invite_link}
                    customSlot
                    onCopy={() =>
                        hapticFeedback.notificationOccurred("success")
                    }
                >
                    <Button className="bg-bg_0 block px-0 py-0 w-auto h-auto">
                        <div className="flex items-center justify-center w-[54px] h-[54px] rounded-[12px] border-[0.5px] border-border_warning">
                            <IconCopy className="text-[24px] text-brand_1" />
                        </div>
                    </Button>
                </Copy>
            </div>

            <ModalQrCode ref={refModalQrCode} invite_link={invite_link} />
        </div>
    );
}
